import React, { useState } from 'react';
import { OfficerLayout } from '../../components/layout/OfficerLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Download, Copy, Share2, CheckCircle2, Calendar, AlertCircle, ChevronLeft, Video, FileText, Instagram, Facebook, Youtube } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
export function DetailAssignmentPage() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const [isCopied, setIsCopied] = useState(false);
  const handleCopyCaption = () => {
    navigator.clipboard.writeText('Mari sukseskan HPSN 2025! Pilah sampah dari rumah untuk Indonesia bersih. #HPSN2025 #PilahSampah');
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };
  return <OfficerLayout data-id="element-2787">
      <div className="pb-32" data-id="element-2788">
        {/* Header Navigation */}
        <div className="flex items-center gap-2 mb-4" data-id="element-2789">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} className="-ml-2" data-id="element-2790">
            <ChevronLeft className="h-6 w-6" data-id="element-2791" />
          </Button>
          <h1 className="text-lg font-bold text-gray-900" data-id="element-2792">Detail Tugas</h1>
        </div>

        {/* Main Content */}
        <div className="space-y-6" data-id="element-2793">
          {/* Status Banner */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex items-start gap-3" data-id="element-2794">
            <AlertCircle className="h-5 w-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-2795" />
            <div data-id="element-2796">
              <h3 className="font-bold text-yellow-800 text-sm" data-id="element-2797">
                Belum Selesai (1/2 Platform)
              </h3>
              <p className="text-xs text-yellow-700 mt-1" data-id="element-2798">
                Segera posting di TikTok sebelum deadline 21 Feb 2025.
              </p>
            </div>
          </div>

          {/* Content Preview */}
          <Card data-id="element-2799">
            <div className="aspect-video bg-gray-100 flex items-center justify-center border-b relative" data-id="element-2800">
              <Video className="h-16 w-16 text-gray-400" data-id="element-2801" />
              <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded" data-id="element-2802">
                01:30
              </div>
            </div>
            <CardContent className="p-4" data-id="element-2803">
              <h2 className="font-bold text-lg text-gray-900 mb-2" data-id="element-2804">
                Kampanye HPSN 2025: Pilah Sampah
              </h2>
              <div className="flex flex-wrap gap-2 mb-4" data-id="element-2805">
                <Badge variant="secondary" data-id="element-2806">Instagram</Badge>
                <Badge variant="secondary" data-id="element-2807">TikTok</Badge>
              </div>

              <Button className="w-full gap-2 mb-2" variant="outline" data-id="element-2808">
                <Download className="h-4 w-4" data-id="element-2809" /> Download Video (15 MB)
              </Button>
            </CardContent>
          </Card>

          {/* Platform Progress Checklist */}
          <Card data-id="element-2810">
            <CardContent className="p-4" data-id="element-2811">
              <h3 className="font-bold text-gray-900 text-sm mb-3" data-id="element-2812">
                Status Posting
              </h3>
              <div className="space-y-3" data-id="element-2813">
                <div className="flex items-center justify-between p-3 bg-green-50 border border-green-100 rounded-lg" data-id="element-2814">
                  <div className="flex items-center gap-3" data-id="element-2815">
                    <Instagram className="h-5 w-5 text-pink-600" data-id="element-2816" />
                    <div data-id="element-2817">
                      <p className="text-sm font-medium text-gray-900" data-id="element-2818">
                        Instagram
                      </p>
                      <p className="text-xs text-green-600" data-id="element-2819">Sudah disubmit</p>
                    </div>
                  </div>
                  <CheckCircle2 className="h-5 w-5 text-green-600" data-id="element-2820" />
                </div>

                <div className="flex items-center justify-between p-3 bg-gray-50 border border-gray-200 rounded-lg" data-id="element-2821">
                  <div className="flex items-center gap-3" data-id="element-2822">
                    <span className="h-5 w-5 flex items-center justify-center font-bold text-xs bg-black text-white rounded-full" data-id="element-2823">
                      TT
                    </span>
                    <div data-id="element-2824">
                      <p className="text-sm font-medium text-gray-900" data-id="element-2825">
                        TikTok
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-2826">Belum diposting</p>
                    </div>
                  </div>
                  <Button size="sm" variant="outline" className="h-8 text-xs" onClick={() => navigate(`/officer/submit-bukti/${id}`)} data-id="element-2827">
                    Submit
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Caption Section */}
          <Card data-id="element-2828">
            <CardContent className="p-4" data-id="element-2829">
              <div className="flex justify-between items-center mb-2" data-id="element-2830">
                <h3 className="font-bold text-gray-900 text-sm" data-id="element-2831">
                  Caption Wajib
                </h3>
                <Button size="sm" variant="ghost" className="h-8 text-primary-600" onClick={handleCopyCaption} data-id="element-2832">
                  {isCopied ? <CheckCircle2 className="h-4 w-4 mr-1" data-id="element-2833" /> : <Copy className="h-4 w-4 mr-1" data-id="element-2834" />}
                  {isCopied ? 'Tersalin' : 'Salin'}
                </Button>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg border text-sm text-gray-700 font-mono leading-relaxed select-all" data-id="element-2835">
                Mari sukseskan HPSN 2025! Pilah sampah dari rumah untuk
                Indonesia bersih.
                <br data-id="element-2836" />
                <br data-id="element-2837" />
                Langkah kecil kita berdampak besar bagi lingkungan. Mulai hari
                ini, pisahkan sampah organik dan anorganik.
                <br data-id="element-2838" />
                <br data-id="element-2839" />
                #HPSN2025 #PilahSampah #IndonesiaBersih #KLHK
              </div>
            </CardContent>
          </Card>

          {/* Instructions */}
          <Card data-id="element-2840">
            <CardContent className="p-4" data-id="element-2841">
              <h3 className="font-bold text-gray-900 text-sm mb-2" data-id="element-2842">
                Instruksi Posting
              </h3>
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1" data-id="element-2843">
                <li data-id="element-2844">Posting di Feed Instagram & TikTok</li>
                <li data-id="element-2845">Wajib tag akun @kementerianLHK</li>
                <li data-id="element-2846">Gunakan hashtag yang sudah disediakan</li>
                <li data-id="element-2847">Posting pada jam prime time (17:00 - 20:00)</li>
              </ul>
            </CardContent>
          </Card>
        </div>

        {/* Bottom Action Bar - Fixed Position Adjusted */}
        <div className="fixed bottom-16 left-0 right-0 p-4 bg-white border-t shadow-lg z-20 pb-safe" data-id="element-2848">
          <div className="max-w-lg mx-auto" data-id="element-2849">
            <Button className="w-full bg-primary-600 hover:bg-primary-700 text-white h-12 text-lg font-medium shadow-md" onClick={() => navigate(`/officer/submit-bukti/${id}`)} data-id="element-2850">
              <Share2 className="h-5 w-5 mr-2" data-id="element-2851" /> Submit Bukti Posting
            </Button>
          </div>
        </div>
      </div>
    </OfficerLayout>;
}